import React from 'react';
import styles from './index.css';
import PropTypes from 'prop-types';
import { LazyImg } from '@ifeng-fe/ui_pc_lazyLoad';
import { formatImage } from '../../../../../../base/publicMethod/index';
import { WxLaunchApp } from '../../../../../wxLaunchApp';
import { callApp, getSchemeLink, getWebAppLink } from '@ifeng-fe/callapp';
import { formatTime } from '../../../utils/formatTime';

class ShortHead extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    handleCallup = (isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
        const { content } = this.props;

        if (isCallApp) {
            if (content && content.callAppConfig) {
                content.callAppConfig.isCopySchemeUrl = isJumpQQlink;
                callApp(content.callAppConfig);
            } else {
                callApp({
                    docType: 'doc',
                    pid: content._id || content.base62Id || '',
                    kind: 'share01',
                    download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725251042',
                    downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7641',
                    isCopySchemeUrl: isJumpQQlink,
                });
            }
        }
    };

    render() {
        const {
            content,
            content: { isVideoShare, wxLaunchSwitch, wxLaunchType },
        } = this.props;
        const mediaUrl =
            (content.subscribe &&
                content.subscribe.cateid !== content.subscribe.catename &&
                content.subscribe.type === 'vampire' &&
                content.subscribe.forbidJump == '0' &&
                `https://ishare.ifeng.com/mediaShare/home/${content.subscribe.cateid}/media`) ||
            'javascript:;';
        const updataTime = content.newsTime && formatTime(content.newsTime);
        const schemeLink =
            wxLaunchType === 'weapp'
                ? getWebAppLink({
                      docType: 'short',
                      pid: content._id || content.base62Id,
                  })
                : getSchemeLink({
                      docType: 'doc',
                      pid: content._id || content.base62Id,
                      kind: 'share01',
                  });

        return (
            <div className={styles.shortRelateHead}>
                {content.subscribe && content.subscribe.logo && (
                    <div className={styles.shortRelateHeadImg}>
                        <a href={mediaUrl}>
                            <LazyImg
                                className={styles.shortRelateHeadPic}
                                placeholder='data:image/svg+xml;utf8,<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="64" height="64"><rect x="0" y="0" width="349" height="196" fill="%23f2f2f2"/></svg>'
                                src={formatImage(content.subscribe.logo.replace(/\.webp|_webp/g, ''), 64, 64)}
                            />
                            {content.subscribe.honorImg && (
                                <img src={content.subscribe.honorImg} className={styles.shortRelateHeadPicV} />
                            )}
                        </a>
                    </div>
                )}

                <a href={mediaUrl} className={styles.shortRelateHeadText}>
                    {content.subscribe && (
                        <div className={styles.shortRelateHeadName}>
                            {content.subscribe.catename}
                            {content.subscribe.cateSource === '大风号' && (
                                <span className={styles.shortRelateHeadDfh} />
                            )}
                        </div>
                    )}
                    {(updataTime || (content.subscribe && content.subscribe.description)) && (
                        <div className={styles.shortRelateHeadInfo}>
                            {content.subscribe.originalName && (
                                <span className={styles.shortRelateOriginal}>{content.subscribe.originalName}</span>
                            )}
                            {updataTime && <span className={styles.shortRelateHeadTime}>{updataTime}</span>}
                            {content.subscribe && content.subscribe.description && (
                                <span className={styles.shortRelateHeadBref}>{content.subscribe.description}</span>
                            )}
                        </div>
                    )}
                </a>
                <div className={styles.shortRelateHeadFollow}>
                    <span className={styles.shortRelateHeadBtn} onClick={this.handleCallup}>
                        关注
                    </span>
                    {!isVideoShare && wxLaunchSwitch && (
                        <WxLaunchApp
                            launchType={wxLaunchType}
                            launchAppClick={this.handleCallup.bind(this, true, false, false)}
                            schemeLink={schemeLink}
                            launchAppFail={this.handleCallup.bind(this, false, true, true)}
                        />
                    )}
                </div>
            </div>
        );
    }
}

export default ShortHead;
